<template>
  <div>
    <pcHeader></pcHeader>
    <div class="pc_cart_box">
      <div class="pc_cart_title clearfix_">
        <div class="pc_cart_title_txt fl">全部商品</div>
        <div v-show="storedValueCard.isExist" class="pc_cart_stored_value_card fr clearfix_">
          <div class="fl pc_cart_stored_value_card_txt">{{storedValueCard.overlap}}</div>
          <div class="fl">
            <el-switch class="pc_cart_stored_value_card_radio fl" @change="changeStoredValueCard" v-model="storedValueCardVal" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            <div class="fl pc_cart_stored_value_card_price">￥{{storedValueCard.balance}}<span v-show="storedValueCard.discount">/</span>{{storedValueCard.discount}}</div>
          </div>
        </div>
      </div>
      <div v-show="promotionList.length" class="pc_cart_promotion_box">
        <div class="pc_cart_promotion_title">有可参加的促销</div>
        <div :style="{height:promotionMore?'auto':'12px'}" class="pc_cart_promotion_list">
          <div v-for="(item,index) in promotionList" :key="index" class="pc_cart_promotion_item clearfix_">
            <div :title="item.condition+item.method+item.pmnPrivilege" class="fl pc_cart_promotion_item_txt">{{item.condition}}{{item.method}}{{item.pmnPrivilege}}</div>
            <div :title="item.method" class="fl pc_cart_promotion_item_type1">{{item.method}}</div>
            <div class="fl pc_cart_promotion_item_type2">{{item.type}}</div>
          </div>
        </div>
        <div @click="promotionMoreFn" class="pc_cart_promotion_more">{{promotionMore?'收起促销':'更多促销'}}</div>
      </div>
      <div class="pc_cart_goods_box">
        <div class="pc_cart_goods_title clearfix_">
          <div @click="changeCheckedAll(1)" class="fl pc_cart_goods_title_all clearfix">
            <div :class="checkAllFlag==1?'pc_cart_goods_title_all_active':''" class="fl pc_cart_goods_title_all_img"></div>
            <div class="fl">全选</div>
          </div>
          <div class="fl pc_cart_goods_title_name">商品信息</div>
          <div class="fl pc_cart_goods_title_price">单价</div>
          <div class="fl pc_cart_goods_title_num">数量</div>
          <div class="fl pc_cart_goods_title_money">金额</div>
          <div class="fl pc_cart_goods_title_btn">操作</div>
        </div>
        <div class="pc_cart_goods_list">
          <div v-for="(item,index) in goodsList" :key="index" class="pc_cart_goods_item clearfix_">
            <div v-if="item.type==5" class="pc_cart_goods_item_bg"></div>
            <div @click="changeChecked(item,0)" :class="item.isSelected==1?'pc_cart_goods_item_radio_active':''" class="fl pc_cart_goods_item_radio"></div>
            <div class="fl pc_cart_goods_item_img"><img :src="item.pic?item.pic:noImg" alt=""></div>
            <div class="fl pc_cart_goods_item_name">{{item.goodsName}}</div>
            <div class="fl pc_cart_goods_item_attr">
              <div class="pc_cart_goods_item_attr_property">{{item.property1}}</div>
              <div class="pc_cart_goods_item_attr_unit">{{item.goodsUnitName}}</div>
              <div @click="modifyAttr(item)" class="pc_cart_goods_item_attr_modify">修改</div>
            </div>
            <div v-show="item.isModify" class="pc_cart_goods_item_attr_modify_box clearfix_">
              <div class="fl pc_cart_goods_item_attr_modify_attr_box">
                <div class="pc_cart_goods_item_attr_modify_attr_list">
                  <div v-for="(val,idx) in item.quteItem.attribute" :key="idx" class="pc_cart_goods_item_attr_modify_attr_item clearfix_">
                    <div class="fl pc_cart_goods_item_attr_modify_attr_item_name">{{val.name}}</div>
                    <div class="fl pc_cart_goods_item_attr_modify_attr_item_val_list clearfix_">
                      <div @click="changGoodsItemAttr(index,idx,i)" v-for="(v,i) in val.attribute_val" :key="i" :class="{'pc_cart_goods_item_attr_modify_attr_item_val_active':v.isChecked}" class="fl pc_cart_goods_item_attr_modify_attr_item_val">{{v.otherName?v.otherName:v.name}}</div>
                    </div>
                  </div>
                </div>
                <div class="pc_cart_goods_item_attr_modify_btn clearfix_">
                  <div @click="changeNum(item,2)" :class="{'pc_cart_goods_item_attr_modify_btn_active':item.isChangeAttr}" class="fl pc_cart_goods_item_attr_modify_btn1">确定</div>
                  <div @click="offModifyAttr(item)" class="fl pc_cart_goods_item_attr_modify_btn2">取消</div>
                </div>
              </div>
              <div class="fl pc_cart_goods_item_attr_modify_pic"><img :src="item.pic?item.pic:noImg" alt=""></div>
            </div>
            <div class="fl pc_cart_goods_item_price">
              <div class="pc_cart_goods_item_price_num">{{item.salesMoney}}</div>
              <div class="pc_cart_goods_item_price_promotion">
                <div v-show="item.promotionData.length" class="pc_cart_goods_item_price_promotion_title">促销</div>
                <div class="pc_cart_goods_item_price_promotion_list">
                  <div v-for="(val,idx) in item.promotionData" :key="idx" class="pc_cart_goods_item_price_promotion_item">{{idx+1}} {{val.method}} : {{val.condition}}{{val.method}}{{val.pmnPrivilege}} {{val.overlap}}</div>
                </div>
              </div>
            </div>
            <div class="fl pc_cart_goods_item_num_box">
              <div class="pc_cart_goods_item_num clearfix_">
                <div @click="changeNum(item,-1)" class="fl pc_cart_goods_item_num_reduce">-</div>
                <div class="fl pc_cart_goods_item_num_input"><input @blur="changeNum(item,0)" v-model="item.num" type="number"></div>
                <div @click="changeNum(item,1)" class="fl pc_cart_goods_item_num_plus">+</div>
              </div>
              <div class="pc_cart_goods_item_num_txt">{{item.message}}</div>
            </div>
            <div class="fl pc_cart_goods_item_money">
              <div class="pc_cart_goods_item_money_txt">{{item.totalPrice}}</div>
              <div class="pc_cart_goods_item_money_discount"><span v-show="parseFloat(item.privilege)">优惠 {{item.privilege}}</span> <span v-show="item.score">{{item.score}}分</span> <span v-show="item.giftNum">赠{{item.giftNum}}</span></div>
            </div>
            <div class="fl pc_cart_goods_item_btn_box">
              <div @click="moveCollection(item)" class="pc_cart_goods_item_btn">{{item.isCollection?'已收藏':'移入收藏'}}</div>
              <div @click="deleteGoods(item)" class="pc_cart_goods_item_btn">删除</div>
            </div>
          </div>
          <div v-show="page!=lastPage&&!loading" @click="moreGoods" class="pc_cart_goods_more">查看更多</div>
          <div v-show="loading" class="pc_cart_goods_more">正在加载</div>
          <div v-show="invalidGoodsBlock" class="clearfix_"><div @click="deleteInvalidGoods" class="pc_cart_invalid_goods fr">清空失效商品</div></div>
        </div>
        <div class="pc_cart_goods_btn_box clearfix_">
          <div @click="deleteAllGoods" class="fl pc_cart_goods_btn_delete">删除</div>
          <div class="fr pc_cart_goods_btn_price_box clearfix_">
            <div class="fl pc_cart_goods_btn_price1">优惠金额：<span>{{discountPrice}}</span></div>
            <div class="fl pc_cart_goods_btn_price1 pc_cart_goods_btn_price2">合计（不含运费）：<span>{{totalPrice}}</span></div>
            <div @click="toBalance" class="fl pc_cart_goods_btn">结&nbsp;&nbsp;算</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
import pcHeader from '@/components/index/search'
export default {
  inject:['reload'],
  data(){
    return{
      noImg:require("@/assets/img/aa.png"),
      storedValueCard:{},
      isUseMemberCardRuleDiscount:0,
      isUseMemberCardRuleBalance:0,
      storedValueCardVal:true,
      promotionList:[],
      promotionMore:false,
      page:1,
      digit:2,
      checkAllFlag:0,
      lastPage:null,
      goodsList:[],
      cardarrIds:[],
      loading:true,
      totalPrice:0,
      discountPrice:0,
      invalidGoodsBlock:false
    }
  },
  components:{
    pcHeader
  },
  mounted(){
    this.isExistMemberCardRule()
    this.getPromotionDataForShoppingCart()
  },
  methods:{
    go404:function(msg){
      var href=this.$router.resolve({name:'err404',query:{txt:msg}})
      return window.open(href.href,'_blank')
    },
    goSignIn:function(){
      localStorage.removeItem('tamp')
      localStorage.removeItem('name')
      return this.$router.push({
        name: 'loginHome',
        query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
      });
    },
    gotoGoodsDetail:function(item){
      var href=this.$router.resolve({name:'goodsdetails',query:{goodsId:item.goodsId,supplyChainTenantId:item.supplyChainTenantId,isSupplyChainGoods:2}})
      return window.open(href.href,'_blank')
    },
    toBalance:function () {
      var t_=this
      if(t_.cardarrIds.length==0)return this.$message({
        message:'您还没有选择要结算的商品',
        center:true,
        type:'warning'
      })
      if(t_.cardarrIds.length>50 )return this.$message({
        message:'最多只能为50个宝贝下单哦~！',
        center:true,
        type:'warning'
      })
      if(t_.storedValueCard.isExist&&t_.storedValueCardVal){
        if(parseFloat(t_.totalPrice.toFixed(t_.digit))>parseFloat(t_.storedValueCard.balance)){
          t_.$confirm('储值卡金额不足,继续购买将采用其它支付方式,不再享受储值折扣','提示',{
            confirmButtonText:'使用',
            cancelButtonText:'不使用',
            distinguishCancelAndClose:true,
            type:'warning'
          }).then(()=>{
            var cardIds = t_.cardarrIds.join()
            t_.isUseMemberCardRuleDiscount=0
            t_.isUseMemberCardRuleBalance=1
            t_.$router.push({name:'settlement',query:{ids:cardIds,type:"",isUseMemberCardRuleDiscount:t_.isUseMemberCardRuleDiscount,isUseMemberCardRuleBalance:t_.isUseMemberCardRuleBalance}})
          }).catch(action=>{
            if(action=='cancel'){
              var cardIds = t_.cardarrIds.join()
              t_.isUseMemberCardRuleDiscount=0
              t_.isUseMemberCardRuleBalance=0
              t_.$router.push({name:'settlement',query:{ids:cardIds,type:"",isUseMemberCardRuleDiscount:t_.isUseMemberCardRuleDiscount,isUseMemberCardRuleBalance:t_.isUseMemberCardRuleBalance}})
            }
          })
        }else{
          t_.isUseMemberCardRuleDiscount=1
          t_.isUseMemberCardRuleBalance=1
          var cardIds = t_.cardarrIds.join()
          t_.$router.push({name:'settlement',query:{ids:cardIds,type:"",isUseMemberCardRuleDiscount:t_.isUseMemberCardRuleDiscount,isUseMemberCardRuleBalance:t_.isUseMemberCardRuleBalance}})
        }
      }else{
        var cardIds = t_.cardarrIds.join()
        t_.isUseMemberCardRuleDiscount=0
        t_.isUseMemberCardRuleBalance=0
        t_.$router.push({name:'settlement',query:{ids:cardIds,type:"",isUseMemberCardRuleDiscount:t_.isUseMemberCardRuleDiscount,isUseMemberCardRuleBalance:t_.isUseMemberCardRuleBalance}})
      }
    },
    calculationPrice:function(){
      var t_=this
      t_.totalPrice=0
      t_.discountPrice=0
      var total=0
      t_.goodsList.forEach(function(item,index){
        if(item.isSelected==1){
          total+=parseFloat(item.totalPrice)
          t_.discountPrice+=parseFloat(item.privilege)
        }
      })
      total+=t_.discountPrice
      t_.totalPrice=total.toFixed(t_.digit)
      t_.discountPrice=(0-t_.discountPrice).toFixed(t_.digit)
    },
    moreGoods:function(){
      if(this.page==this.lastPage)return
      ++this.page
      this.getShoppingCart()
    },
    changeChecked:function(item,type){
      this.changeCheckedFn(item,type)
    },
    changeCheckedAll:function(type){
      this.changeCheckedFn('',type)
    },
    changeCheckedFn:function(item,type){
      var t_=this
      var data={
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2
      }
      if(type){
        if(t_.checkAllFlag==1){
          data.status=2
        }else{
          data.status=1
        }
      }else{
        if(item.isSelected==1){
          data.status=2
        }else{
          data.status=1
        }
        data.id=item.id
      }
      axios.post(`${ip}formWorkInterface/updateShoppingCart`,Qs.stringify(data)).then(res=>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.checkAllFlag=res.data.allStatus
          if(type){
            if(res.data.allStatus==2){
              t_.goodsList.forEach(function(val,idx){
                val.isSelected=2
              })
              t_.cardarrIds=[]
            }else{
              t_.cardarrIds=[]
              t_.goodsList.forEach(function(item,index){
                item.isSelected=1
                t_.cardarrIds.push(item.id)
              })
            }
          }else{
            if(res.data.status==1){
              item.isSelected = 1
              t_.cardarrIds.push(item.id);
            }else{
              item.isSelected = 2
              for(var i = 0; i < t_.cardarrIds.length;i++){
                if(t_.cardarrIds[i] == item.id){
                  t_.cardarrIds.splice(i,1);
                }
              }
            }
          }
          t_.calculationPrice()
        }
      })
    },
    deleteInvalidGoods:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
      })
      axios.post(`${ip}formWorkInterface/emptyFailure`,data0bj).then(res=>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
          t_.$store.commit('ccc')
          t_.reload()
        }
      })
    },
    deleteGoods:function(item){
      this.deleteGoodsFn(item.id)
    },
    deleteAllGoods:function(){
      this.deleteGoodsFn(this.cardarrIds.join(','))
    },
    deleteGoodsFn:function(ids){
      var t_=this
      if(!ids)return this.$message({
        message:'请选择要删除的商品',
        center:true,
        type:'warning'
      })
      t_.$confirm('确认删除商品吗？','提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        distinguishCancelAndClose:true,
        type:'warning'
      }).then(()=>{
        let data = Qs.stringify({"tamp":localStorage.tamp?localStorage.tamp:'',"channel":2,"cartId":ids})
        axios.post(`${ip}formWorkInterface/deleteShopping`,data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
          if(res.data.code == 0){
            this.$message({
              message:'删除商品成功',
              center:true,
              type:'success'
            })
            t_.$store.commit('ccc')
            t_.reload()
          }
        })
      }).catch(action=>{})
    },
    moveCollection:function(item){
      var t_=this
      if(item.isCollection)return
      var data = Qs.stringify({"tamp":localStorage.tamp?localStorage.tamp:'',"channel":2,"id":item.id});
      axios.post(`${ip}formWorkInterface/moveCollection`,data).then(res=>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.$message({
            message:'收藏成功',
            center:true,
            type:'seccess'
          })
          t_.$store.commit('ccc')
          return t_.reload()
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    isExistMemberCardRule:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
      })
      axios.post(`${ip}formWorkInterface/isExistMemberCardRule`,data0bj).then(res=>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.storedValueCard=res.data.data
          if(res.data.data.isExist==1){
            t_.isUseMemberCardRuleDiscount=1
            t_.isUseMemberCardRuleBalance=1
          }
          t_.getShoppingCart()
        }
      })
    },
    changeStoredValueCard:function(){
      var t_=this
      t_.goodsList=[]
      t_.cardarrIds=[]
      if(t_.storedValueCardVal){
        t_.isUseMemberCardRuleDiscount=1
        t_.isUseMemberCardRuleBalance=1
        t_.getShoppingCart()
      }else{
        t_.isUseMemberCardRuleDiscount=0
        t_.isUseMemberCardRuleBalance=0
        t_.getShoppingCart()
      }
    },
    getPromotionDataForShoppingCart:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
      })
      axios.post(`${ip}formWorkInterface/getPromotionDataForShoppingCart`,data0bj).then(res=>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.promotionList=res.data.data
        }
      })
    },
    promotionMoreFn:function(){
      this.promotionMore=!this.promotionMore
    },
    getShoppingCart:function () {
      var t_=this
      t_.loading=true
      let data = Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        page:t_.page,
        channel:2,
        pagesize:10,
        isUseMemberCardRuleDiscount:t_.isUseMemberCardRuleDiscount,
        isUseMemberCardRuleBalance:t_.isUseMemberCardRuleBalance
      })
      axios.post(`${ip}formWorkInterface/getShoppingCart`,data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.loading=false
          t_.digit=res.data.rows.decimalPlace
          t_.checkAllFlag=res.data.rows.allStatus
          t_.lastPage=res.data.rows.lastPage
          t_.cardarrIds=[]
          res.data.rows.goodsData.forEach(function(item,index){
            t_.$set(item,"isModify",0)
            t_.$set(item,"isChangeAttr",0)
            item.quteItem.unitData.forEach(function(val,idx){
              t_.$set(val,"sid",val.id);
            })
            item.quteItem.attribute.unshift({
              name:'单位',
              attribute_val:item.quteItem.unitData
            })
            item.quteItem.attribute.forEach(function(val,idx){
              val.attribute_val.forEach(function(v,i){
                t_.$set(v,"isChecked",false);
              })
            })
          })
          t_.goodsList = t_.goodsList.concat(res.data.rows.goodsData)
          t_.goodsList.forEach(function(item,index){
            if(item.isSelected==1){
              t_.cardarrIds.push(item.id)
            }
          })
          for(var i = 0; i < res.data.rows.goodsData.length; i++){
            if(res.data.rows.goodsData[i].type==5){
              t_.invalidGoodsBlock=true
              break
            }else{
              t_.invalidGoodsBlock=false
            }
          }
          t_.calculationPrice()
        }
      })
    },
    changGoodsItemAttr:function(idx0,idx1,idx2){
      var t_=this
      if(t_.goodsList[idx0].quteItem.attribute[idx1].attribute_val[idx2].isChecked){
        t_.goodsList[idx0].quteItem.attribute[idx1].attribute_val[idx2].isChecked=false
      }else{
        t_.goodsList[idx0].quteItem.attribute[idx1].attribute_val.forEach(function(item,index){
          item.isChecked=false
        },t_)
        t_.goodsList[idx0].quteItem.attribute[idx1].attribute_val[idx2].isChecked=true
      }
      var changGoodsItemAttrIds=''
      t_.goodsList[idx0].quteItem.attribute.forEach(function(item,index){
        item.attribute_val.forEach(function(val,idx){
          if(val.isChecked)changGoodsItemAttrIds+=val.sid+'|'
        })
      })
      changGoodsItemAttrIds=changGoodsItemAttrIds.substr(0,changGoodsItemAttrIds.length-1)
      console.log( changGoodsItemAttrIds )
      for(var i=0;i<t_.goodsList[idx0].quteItem.quotationItem.length;i++){
        if(changGoodsItemAttrIds==t_.goodsList[idx0].quteItem.quotationItem[i].group){
          if(t_.goodsList[idx0].allowLoseStock==2){
            t_.goodsList[idx0].isChangeAttr=1
            t_.changGoodsItemAttrIds=changGoodsItemAttrIds
            break
          }else{
            if(t_.goodsList[idx0].quteItem.quotationItem[i].num>0){
              t_.goodsList[idx0].isChangeAttr=1
              t_.changGoodsItemAttrIds=changGoodsItemAttrIds
              break
            }
          }
        }else{
          t_.goodsList[idx0].isChangeAttr=0
        }
      }
    },
    changeNum:function(item,type){
      var t_=this
      var newNum=item.num
      if(type==-1){
        if(newNum<=1)return
        --newNum
      }else if(type==0){
        if(newNum<1)return item.num=1
        if(newNum>200)return item.num=1
        if(newNum>=item.stockNum&&item.allowLoseStock!=2)return item.num=1
      }else if(type==1){
        if(newNum>200)return
        ++newNum
      }else if(type==2){
        if(t_.changGoodsItemAttrIds){
          var strArr=t_.changGoodsItemAttrIds.split('|')
          var goodsUnitId=strArr.shift()
          var property2=strArr.join('|')
          property2='|'+property2
          property2=property2+'|'
          var goodsId=item.goodsId
          if(property2=='||')property2=''
          console.log( property2 )
        }
      }
      var data={
        tamp:localStorage.tamp?localStorage.tamp:'',
        iscard:1,
        channel:2,
        num:newNum,
        cartId:item.id,
        isUseMemberCardRuleDiscount:t_.isUseMemberCardRuleDiscount
      }
      if(goodsUnitId)data.goodsUnitId=goodsUnitId
      if(property2)data.property2=property2
      if(goodsId)data.goodsId=goodsId
      data=Qs.stringify(data)
      axios.post(`${ip}formWorkInterface/updateShopping`,data).then(res =>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.goodsList.forEach(function(item,index){
            item.isChangeAttr=0
            item.isModify=0
            if(item.id==res.data.rows.id){
              item.num=res.data.rows.num
              item.totalPrice=res.data.rows.totalPrice
              item.goodsUnitName=res.data.rows.goodsUnitName
              item.property1=res.data.rows.property1
              item.salesMoney=res.data.rows.salesMoney
              item.message=res.data.rows.message
              item.score=res.data.rows.score
              item.promotionData=res.data.rows.promotionData
              item.giftNum=res.data.rows.giftNum
              item.privilege=res.data.rows.privilege
            }
          })
          t_.changGoodsItemAttrIds=''
          t_.$store.commit('ccc')
          t_.calculationPrice()
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    modifyAttr:function(val){
      this.goodsList.forEach(function(item,index){
        item.isModify=0
      })
      val.isModify=1
    },
    offModifyAttr:function(val){
      val.isModify=0
    },
  }
}
</script>
<style scoped>
.pc_cart_box{
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;
}
.pc_cart_title{
  height: 35px;
  border-bottom: 2px solid #e6e6e6;
  padding-top: 30px;
  margin-bottom: 30px;
}
.pc_cart_title_txt{
  width: 150px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border-bottom: 2px solid #fa0;
  color: #fa0;
  font-size: 18px;
}
.pc_cart_stored_value_card_txt{
  line-height: 20px;
  margin-right: 20px;
}
.pc_cart_stored_value_card_radio{
  margin-right: 10px;
}
.pc_cart_stored_value_card_price{
  line-height: 20px;
  font-size: 14px;
}
.pc_cart_stored_value_card{
  margin-right: 100px;
}
.pc_cart_promotion_title{
  color: #a8a8a8;
  margin-left: 8px;
  margin-bottom: 15px;
}
.pc_cart_promotion_item{
  margin-bottom: 15px;
}
.pc_cart_promotion_item:last-child{
  margin-bottom: 0;
}
.pc_cart_promotion_item_txt{
  color: #fa0;
  width: 330px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pc_cart_promotion_item_type1{
  text-align: right;
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 12px;
}
.pc_cart_promotion_item_type2{
  margin-left: 100px;
}
.pc_cart_promotion_list{
  margin-bottom: 15px;
  margin-left: 8px;
  overflow: hidden;
}
.pc_cart_promotion_more{
  margin-left: 8px;
  cursor: pointer;
}
.pc_cart_promotion_box{
  margin-bottom: 15px;
}
.pc_cart_goods_title{
  border-bottom: 2px solid #aaa;
  padding: 0 10px;
  padding-bottom: 20px;
  margin-bottom: 10px;
}
.pc_cart_goods_title_all{
  width: 100px;
}
.pc_cart_goods_title_all_img{
  width: 20px;
  height: 20px;
  background: url("http://img.source.9188cn.com/pc_cart_checked.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 15px;
}
.pc_cart_goods_title_all .pc_cart_goods_title_all_active{
  background: url("http://img.source.9188cn.com/pc_cart_checked_red.png") no-repeat;
}
.pc_cart_goods_title_all div:last-child{
  line-height: 20px;
}
.pc_cart_goods_title_name{
  width: 380px;
  text-align: center;
  margin-right: 100px;
  line-height: 20px;
}
.pc_cart_goods_title_price,.pc_cart_goods_title_num,.pc_cart_goods_title_money,.pc_cart_goods_title_btn{
  width: 150px;
  text-align: center;
  line-height: 20px;
}
.pc_cart_goods_item{
  width: 1178px;
  height: 90px;
  padding: 5px 10px;
  margin-bottom: 10px;
  border: 1px solid #efefef;
  position: relative;
}
.pc_cart_goods_item_radio{
  width: 20px;
  height: 20px;
  background: url("http://img.source.9188cn.com/pc_cart_checked.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 30px;
}
.pc_cart_goods_item_radio_active{
  background: url("http://img.source.9188cn.com/pc_cart_checked_red.png") no-repeat;
}
.pc_cart_goods_item_img{
  width: 80px;
  height: 80px;
  padding: 5px;
  margin-right: 20px;
}
.pc_cart_goods_item_img img{
  width: 80px;
  height: 80px;
}
.pc_cart_goods_item_name{
  width: 245px;
  height: 70px;
  margin-top: 5px;
  line-height: 18px;
  cursor: pointer;
}
.pc_cart_goods_item_attr{
  width: 156px;
  height: 91px;
  padding: 0 10px;
  cursor: pointer;
  position: relative;
  border: 1px solid transparent;
}
.pc_cart_goods_item_attr:hover{
  border: 1px dashed  #fa0;
}
.pc_cart_goods_item_attr_property,.pc_cart_goods_item_attr_unit{
  height: 30px;
  line-height: 30px;
  text-align: center;
}
.pc_cart_goods_item_attr_modify{
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background: #ffab00;
  color: #fff;
  display: none;
}
.pc_cart_goods_item_attr:hover .pc_cart_goods_item_attr_modify{
  display: block;
}
.pc_cart_goods_item_attr_modify_box{
  min-height: 209px;
  width: 430px;
  border: 1px solid #d9d9d9;
  position: absolute;
  background: #fff;
  top: 60px;
  left: 415px;
  z-index: 9998;
}
.pc_cart_goods_item_attr_modify_attr_box{
  width: 249px;
  border-right: 1px solid #d9d9d9;
  min-height: 189px;
  padding-top: 20px;
  position: relative;
}
.pc_cart_goods_item_attr_modify_pic{
  width: 160px;
  padding: 25px 10px;
}
.pc_cart_goods_item_attr_modify_pic img{
  width: 160px;
  height: 160px;
}
.pc_cart_goods_item_attr_modify_attr_list{
  max-height: 130px;
  overflow-y: auto;
}
.pc_cart_goods_item_attr_modify_btn{
  position: absolute;
  left: 74px;
  bottom: 20px;
}
.pc_cart_goods_item_attr_modify_btn1{
  margin-right: 5px;
  width: 58px;
  height: 24px;
  color: #fff;
  background: #ababab;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
}
.pc_cart_goods_item_attr_modify_btn2{
  width: 58px;
  height: 24px;
  color: #0b72a4;
  background: #fff;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
}
.pc_cart_goods_item_attr_modify_btn_active{
  background: #f50;
}
.pc_cart_goods_item_attr_modify_attr_item_name{
  width: 75px;
  text-align: center;
  line-height: 22px;
  color: #9d9d9d;
}
.pc_cart_goods_item_attr_modify_attr_item_val{
  width: 38px;
  height: 20px;
  border: 1px solid #d1d1d1;
  line-height: 20px;
  text-align: center;
  margin: 0 10px 10px 0;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pc_cart_goods_item_attr_modify_attr_item_val_active{
  border: 1px solid #ffab00;
}
.pc_cart_goods_item_attr_modify_attr_item_val_list{
  width: 160px;
}
.pc_cart_goods_item_price{
  width: 120px;
  height: 80px;
  padding: 0 10px;
  margin-right: 10px;
  position: relative;
}
.pc_cart_goods_item_price_num{
  width: 120px;
  height: 25px;
  text-align: center;
  line-height: 25px;
}
.pc_cart_goods_item_price_promotion{
  width: 120px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  margin-top: 8px;
  position: relative;
}
.pc_cart_goods_item_price_promotion_title{
  width: 45px;
  height: 22px;
  border: 1px solid #ffb31b;
  color: #ffb31b;
  text-align: center;
  line-height: 22px;
  cursor: pointer;
  margin: 0 auto;
}
.pc_cart_goods_item_price_promotion_list{
  width: 200px;
  border: 1px solid #ccc;
  position: absolute;
  top: 30px;
  background: #fff;
  left: 36px;
  padding: 5px;
  display: none; 
  z-index: 888;
}
.pc_cart_goods_item_price_promotion_item{
  line-height: 18px;
  text-align: left;
  color: #9d9d9d;
}
.pc_cart_goods_item_price_promotion_title:hover+.pc_cart_goods_item_price_promotion_list{
  display: block;
}
.pc_cart_goods_item_num_box{
  width: 125px;
  height: 80px;
  margin: 0 20px;
}
input[type=number] {  
  -moz-appearance:textfield;  
}  
input[type=number]::-webkit-inner-spin-button,  
input[type=number]::-webkit-outer-spin-button {  
  -webkit-appearance: none;  
  margin: 0;  
}
.pc_cart_goods_item_num{
  width: 100px;
  margin-top: 30px;
  height: 25px;
}
.pc_cart_goods_item_num_reduce,.pc_cart_goods_item_num_plus{
  width: 23px;
  height: 23px;
  border: 1px solid #ccc;
  line-height: 23px;
  text-align: center;
  cursor: pointer;
}
.pc_cart_goods_item_num_input{
  width: 50px;
  height: 23px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.pc_cart_goods_item_num_input input{
  width: 50px;
  height: 23px;
  text-align: center;
}
.pc_cart_goods_item_num_txt{
  margin-top: 10px;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  color: #fa0;
}
.pc_cart_goods_item_money{
  width: 127px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  margin-left: 8px;
}
.pc_cart_goods_item_money_txt{
  line-height: 35px;
  color: #e00;
  font-weight: 600;
  font-size: 14px;
}
.pc_cart_goods_item_money_discount{
  font-size: 12px;
  color: rgb(102, 102, 102);
  font-weight: 100;
  line-height: 35px;
}
.pc_cart_goods_item_btn_box{
  width: 140px;
  height: 90px;
  margin-top: 5px;
}
.pc_cart_goods_item_btn{
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  margin-left: 10px;
  cursor: pointer;
}
.pc_cart_goods_more{
  line-height: 26px;
  font-size: 14px;
  color: #333;
  text-align: center;
  cursor: pointer;
  margin-bottom: 10px;
}
.pc_cart_goods_btn_box{
  width: 1200px;
  height: 45px;
  background: #e5e5e5;
}
.pc_cart_goods_btn_delete{
  line-height: 45px;
  color: #2c3e50;
  margin-left: 15px;
  cursor: pointer;
}
.pc_cart_goods_btn_price1{
  line-height: 45px;
  margin-right: 30px;
}
.pc_cart_goods_btn_price1 span{
  font-size: 18px;
  color: #666;
}
.pc_cart_goods_btn_price2 span{
  font-size: 18px;
  color: #e00;
  font-weight: 600;
}
.pc_cart_goods_btn{
  width: 100px;
  height: 45px;
  text-align: center;
  line-height: 45px;
  background: #fa0;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
}
.pc_cart_invalid_goods{
  width: 150px;
  height: 40px;
  background: #fa0;
  border-radius: 5px;
  border: 0;
  color: #fff;
  text-align: center;
  line-height: 40px;
  margin-bottom: 10px;
  cursor: pointer;
}
.pc_cart_goods_item_bg{
  width: 1198px;
  height: 100px;
  position: absolute;
  top:0;
  left:0;
  background:rgba(0, 0, 0, .3);
  z-index: 999;
}
</style>


// WEBPACK FOOTER //
// src/components/shoppCar/index.vue